import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=025b572e&"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Icon/index.vue').default,UiButton: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/index.vue').default,FormLanguageSwitch: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Form/LanguageSwitch.vue').default,UiDialog: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Dialog/index.vue').default})
